<template>
  <ElInput
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    type="textarea"
    placeholder="请输入意图"
    size="small"
  />
</template>

<script setup>
import { ElInput } from 'element-plus';

defineProps({
  modelValue: { type: String, default: '' },
});
defineEmits(['update:modelValue']);
</script>
